import React, {Component} from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { Link } from 'gatsby';
import LogoIberica from '../images/logo-iberica.png';

export default class Header extends Component {
    render() {
        return(
            <div>
                <Navbar collapseOnSelect expand="lg" variant="dark">
                    <Container className="iberica-container">
                            <Link to ="/">
                            <Navbar.Brand>
                                <img src={LogoIberica} className="logo-iberica" alt="Logo Ibérica" sizes="(min-width: 80px) 80px" />
                            </Navbar.Brand>
                            </Link>
                            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                            <Navbar.Collapse id="responsive-navbar-nav">
                                <Nav className="header-iberica-nav">
                                    <Link to="/empresa/" className="link-iberica-header" activeStyle={{borderBottom: "1px solid white"}} style={{textDecoration: "none"}}>Empresa</Link>
                                    <Link to="/produtos/" className="link-iberica-header" activeStyle={{borderBottom: "1px solid white"}} style={{textDecoration: "none"}}>Produtos</Link>
                                    <Link to="/marketing/" className="link-iberica-header" activeStyle={{borderBottom: "1px solid white"}} style={{textDecoration: "none"}}>Marketing</Link>
                                    <Link to="/videos-e-podcasts/" className="link-iberica-header" activeStyle={{borderBottom: "1px solid white"}} style={{textDecoration: "none"}}>Vídeos e Podcasts</Link>
                                    <Link to="/universidade-iberica/" className="link-iberica-header" activeStyle={{borderBottom: "1px solid white"}} style={{textDecoration: "none"}}>Universidade Ibérica</Link>
                                    <Link to="/noticias/" className="link-iberica-header" activeStyle={{borderBottom: "1px solid white"}} style={{textDecoration: "none"}}>Notícias</Link>
                                    <Link to="/contato/" className="link-iberica-header" activeStyle={{borderBottom: "1px solid white"}} style={{textDecoration: "none"}}>Contato</Link>
                                </Nav>
                            </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
        )
    }
}